export const GlobalVariable = Object.freeze({
    BASE_URL : 'https://api.andrewyule.in',
    // BASE_URL : 'http://localhost:3000',
    // BASE_URL : 'http://117.242.186.131:8080',
    //... more of your variables
});


// WEBPACK FOOTER //
// ./src/app/global.ts